<script>
    import DefaultComponent from '../defaultComponent';

    export default {
        ...DefaultComponent,
        computed: {
            ...DefaultComponent.computed,
            fundingAgency() {
                if (this.item.fundingAgency && this.item.fundingAgency.length) return this.item.fundingAgency[0].name;
                return null;
            },
            researchers() {
                if (this.item.researchers && this.item.researchers.length) return this.item.researchers.map(r => r.name).join(', ');
                return null;
            },
            yearString() {
                if (this.item.endYear === this.constants.values.maxYear) return this.item.year;
                return `${this.item.year} - ${this.item.endYear}`;
            },
        },
    }
</script>

<template>
    <a :href="url" :target="target" class="card projectlink is-shadowless">
        <div v-if="item.imageSets && item.imageSets.length && !inSidebar" class="card-image">
            <source-set :imageSets="item.imageSets" />
            <span class="tag is-medium is-white">{{ yearString }}</span>
            <span v-show="fundingAgency" class="tag is-medium is-primary">
                <span class="icon is-small"><i class="fa-solid fa-dollar-sign fa-sm"></i></span>
                <span>{{ fundingAgency }}</span>
            </span>
        </div>
        <div :class="['card-content', 'is-flex-grow-1', 'is-flex', 'is-flex-direction-column', contentClass]">
            <h3 v-show="item.name" :class="['title', titleClass]">{{ item.name }}</h3>
            <p v-show="item.intro" :class="['has-text-black', 'mb-3', textClass]">{{ item.intro }}</p>
            <p v-show="researchers" :class="['has-text-grey-darker', textClass]">{{ researchers }}</p>
        </div>
    </a>
</template>
